import React, { useEffect, useState } from "react";
import "../../../../../styles/ambassadorChallenge/summary.scss";
import { isAuth } from "../../../../../pages/auth/ProtectedRoute";
import axios from "axios";

function Summary() {


    const [overallMetrics, setOverallMetrics] = useState<OverallMetrics | null>(null);

 
  useEffect(() => {
    const fetchOverallMetrics = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_HOST_API}ambassador/overall-metrics`,
          {
            headers: {
              Authorization: `Bearer ${isAuth()}`,
            },
          }
        );
        setOverallMetrics(res.data.data);
      } catch (err: any) {
        console.log("error fetching overall metrics:", err);
      }
    };

    fetchOverallMetrics();
  }, []);

  if(!overallMetrics) return null;

  return (
    <section className="summary">
      <div className="card">
        <div className="title">Total Challenge</div>

        <div className="figureWrapper">
          <div className="figure">{overallMetrics && overallMetrics.total_challenges.toLocaleString()}</div>

          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="8" fill="#F6D9FF" />
            <path
              d="M18.4987 15.9997C20.3404 15.9997 21.832 14.508 21.832 12.6663C21.832 10.8247 20.3404 9.33301 18.4987 9.33301C16.657 9.33301 15.1654 10.8247 15.1654 12.6663C15.1654 14.508 16.657 15.9997 18.4987 15.9997ZM18.4987 10.9997C19.4154 10.9997 20.1654 11.7497 20.1654 12.6663C20.1654 13.583 19.4154 14.333 18.4987 14.333C17.582 14.333 16.832 13.583 16.832 12.6663C16.832 11.7497 17.582 10.9997 18.4987 10.9997ZM18.4987 17.6663C16.2737 17.6663 11.832 18.783 11.832 20.9997V22.6663H25.1654V20.9997C25.1654 18.783 20.7237 17.6663 18.4987 17.6663ZM13.4987 20.9997C13.682 20.3997 16.257 19.333 18.4987 19.333C20.7487 19.333 23.332 20.408 23.4987 20.9997H13.4987ZM10.9987 18.4997V15.9997H13.4987V14.333H10.9987V11.833H9.33203V14.333H6.83203V15.9997H9.33203V18.4997H10.9987Z"
              fill="#8C4A60"
            />
          </svg>
        </div>
      </div>

      <div className="card">
        <div className="title">Total Referrals</div>

        <div className="figureWrapper">
          <div className="figure">{overallMetrics && overallMetrics.total_referrals.toLocaleString()}</div>

          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="8" fill="#F6D9FF" />
            <path
              d="M18.4987 15.9997C20.3404 15.9997 21.832 14.508 21.832 12.6663C21.832 10.8247 20.3404 9.33301 18.4987 9.33301C16.657 9.33301 15.1654 10.8247 15.1654 12.6663C15.1654 14.508 16.657 15.9997 18.4987 15.9997ZM18.4987 10.9997C19.4154 10.9997 20.1654 11.7497 20.1654 12.6663C20.1654 13.583 19.4154 14.333 18.4987 14.333C17.582 14.333 16.832 13.583 16.832 12.6663C16.832 11.7497 17.582 10.9997 18.4987 10.9997ZM18.4987 17.6663C16.2737 17.6663 11.832 18.783 11.832 20.9997V22.6663H25.1654V20.9997C25.1654 18.783 20.7237 17.6663 18.4987 17.6663ZM13.4987 20.9997C13.682 20.3997 16.257 19.333 18.4987 19.333C20.7487 19.333 23.332 20.408 23.4987 20.9997H13.4987ZM10.9987 18.4997V15.9997H13.4987V14.333H10.9987V11.833H9.33203V14.333H6.83203V15.9997H9.33203V18.4997H10.9987Z"
              fill="#8C4A60"
            />
          </svg>
        </div>
      </div>

        <div className="card">
        <div className="title">Total Winners</div>

        <div className="figureWrapper">
          <div className="figure">{overallMetrics && overallMetrics.total_winners.toLocaleString()}</div>

          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill="#FFDADA"/>
            <g clipPath="url(#clip0_11154_60175)">
            <path d="M12.668 23.5H19.3346" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 20.167V23.5003" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.832 9.33301H20.1654" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20.1654 9.33301V15.9997C20.1654 17.1047 19.7264 18.1646 18.945 18.946C18.1636 19.7274 17.1038 20.1663 15.9987 20.1663C14.8936 20.1663 13.8338 19.7274 13.0524 18.946C12.271 18.1646 11.832 17.1047 11.832 15.9997V9.33301" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.1667 15.1663C11.0871 15.1663 11.8333 14.4201 11.8333 13.4997C11.8333 12.5792 11.0871 11.833 10.1667 11.833C9.24619 11.833 8.5 12.5792 8.5 13.4997C8.5 14.4201 9.24619 15.1663 10.1667 15.1663Z" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.8346 15.1663C22.7551 15.1663 23.5013 14.4201 23.5013 13.4997C23.5013 12.5792 22.7551 11.833 21.8346 11.833C20.9142 11.833 20.168 12.5792 20.168 13.4997C20.168 14.4201 20.9142 15.1663 21.8346 15.1663Z" stroke="#8F4A4D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_11154_60175">
            <rect width="20" height="20" fill="white" transform="translate(6 6)"/>
            </clipPath>
            </defs>
        </svg>

        </div>
      </div>

      <div className="card">
        <div className="title">Total Prizes</div>

        <div className="figureWrapper">
          <div className="figure">${Math.round(overallMetrics && overallMetrics.total_prizes).toLocaleString()}</div>

          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="8" fill="#C7F0A6"/>
            <path d="M16.3245 15.0833C14.4328 14.5917 13.8245 14.0833 13.8245 13.2917C13.8245 12.3833 14.6661 11.75 16.0745 11.75C17.5578 11.75 18.1078 12.4583 18.1578 13.5H19.9995C19.9411 12.0667 19.0661 10.75 17.3245 10.325V8.5H14.8245V10.3C13.2078 10.65 11.9078 11.7 11.9078 13.3083C11.9078 15.2333 13.4995 16.1917 15.8245 16.75C17.9078 17.25 18.3245 17.9833 18.3245 18.7583C18.3245 19.3333 17.9161 20.25 16.0745 20.25C14.3578 20.25 13.6828 19.4833 13.5911 18.5H11.7578C11.8578 20.325 13.2245 21.35 14.8245 21.6917V23.5H17.3245V21.7083C18.9495 21.4 20.2411 20.4583 20.2411 18.75C20.2411 16.3833 18.2161 15.575 16.3245 15.0833Z" fill="#3A711A"/>
        </svg>
        </div>
      </div>
    </section>
  );
}

export default Summary;
